import { useDispatch, useSelector } from "react-redux";
import { Menu } from "lucide-react";
import { collapsedSidebarSelect } from "Layout/slice/selector";
import { setCollapsedSidebar } from "Layout/slice";
import { ToggleButton } from "./HamburgerToggle.styles";

export const HamburgerToggle = () => {
  const dispatch = useDispatch();
  const collapsed = useSelector(collapsedSidebarSelect);

  return (
    <ToggleButton
      aria-label="Toggle sidebar"
      onClick={() => dispatch(setCollapsedSidebar(!collapsed))}
    >
      <Menu size={24} strokeWidth={2.5} />
    </ToggleButton>
  );
};
